import { render, staticRenderFns } from "./OverviewStats.vue?vue&type=template&id=c00cb86a"
import script from "./OverviewStats.vue?vue&type=script&lang=js"
export * from "./OverviewStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports